import { LookupValues } from 'src/utils/types';

export const FREQUENCY_TRACKING_PREFIX = 'zhl.mortgageapplicationcenter.frequencytracking';
/**
 * Rather than accepting any event, we require that the event be registered here. This is
 * to discourage name collisions where two different places in the code both use the same event
 * not realizing that there is another code location using the same key.
 */

export const FREQUENCY_TRACKED_EVENTS = {
    SIGN_IN_ATTEMPT: 'signinattempt',
} as const;
export type FrequencyTrackedEvent = LookupValues<typeof FREQUENCY_TRACKED_EVENTS>;
